import React, { useState, useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
// import vehicle from '/image/vehicle.jpg'

const PLACEHOLDER_DESCRIPTION = 'Fill this soon';

const SLIDES = [
  {
    slug: 'property',
    headline: ['Property'],
    subtext:
      "Providing the right and sufficient insurance policy and cover is very critical, not only to protect your tangible assets but also to prevent losses of your business operation, including machinery breakdown.",
    image:
      '/image/property.jpg',
    exhibit: 'Exhibit A — Property',
    content: [
      { label: 'Industrial', description: 'Fill this soon with industrial' },
      { label: 'Commercial', description: 'Fill this soon with commercial' },
      { label: 'Residential', description: 'Fill this soon with residential' },
    ],
  },
  {
    slug: 'motor-vehicle',
    headline: ['Motor Vehicle'],
    subtext:
      "Incidents are imminent where not only businesses are interrupted but also lives are threatened. The financial losses of such an incident could be protected or reduced so you can continue doing your business operations",
    image:
      '/image/vehicle2.png',
    exhibit: 'Exhibit B — Motor Vehicle',
    content: [
      { label: 'Private', description: 'Blablabla' },
      { label: 'Commercial', description: 'Fill this soon with commercial' },
      { label: 'Operational', description: 'Fill this soon with operational' },
    ],
  },
  {
    slug: 'health',
    headline: ['Health'],
    subtext:
      "We work closely with a large group of insurance carriers and administrators for a broad range of benefits with a depth of choices. As a consulting benefits, your dedicated Redoura team will then make recommendations to create an integrated, comprehensive employee benefits solution matching your unique organization",
    image:
      '/image/health.jpg',
    exhibit: 'Exhibit C — Health',
    content: [
      { label: 'Employee Benefits', description: 'Benefits' }
    ],
  },
  {
    slug: 'energy',
    headline: ['Energy'],
    subtext:
      "Our team of professionals have first-hand experience dealing with gas plants, construction, terminals, storage and power facilities, as well as onshore and offshore drilling and production operations, equipment manufacturing for oil, gas, mining and utility industries, oil field services and pipelines.",
    image:
      '/image/energy.jpg',
    exhibit: 'Exhibit D — Energy',
    content: [
      { label: 'Oil & Gas', description: 'Blablabla' },
      { label: 'Power Plant', description: 'Fill this soon with commercial' },
      { label: 'Refining', description: 'Fill this soon with operational' },
      { label: 'Mining', description: 'Fill this soon with operational' },
      { label: 'Process Industries', description: 'Fill this soon with operational' },
    ],
  },
  {
    slug: 'heavy-equipment',
    headline: ['Heavy Equipment'],
    subtext:
      "We work with specialized underwriting, risk engineering and claim professional creating a plan tailored to your needs and in delivering quality service when you need them most.",
    image:
      '/image/heavyequipment.jpg',
    exhibit: 'Exhibit E — Heavy Equipment',
    content: [
      { label: 'Construction', description: 'Blablabla' },
      { label: 'Mining', description: 'Fill this soon with commercial' },
      { label: 'Agriculture', description: 'Fill this soon with operational' },
    ],
  },
  {
    slug: 'liability',
    headline: ['Liability'],
    subtext:
      "Each and every liability insurance policy we provide ensures a high standard of cover protecting you against claims made by a third party or employee for losses or damages",
    image:
      '/image/liability.jpg',
    exhibit: 'Exhibit F — Liability',
    content: [
      { label: 'Public Liability', description: 'Blablabla' },
      { label: 'Employers Liability Insurance', description: 'Fill this soon with commercial' },
    ],
  },
  {
    slug: 'marine',
    headline: ['Marine'],
    subtext:
      "We work with international clubs and underwriters to provide our clients with broad range of highly competitive, first class marine insurance solutions to the risks faced by maritime enterprises in the marine and shipping industry.",
    image:
      '/image/marine.jpg',
    exhibit: 'Exhibit G — Marine',
    content: [
      { label: 'Hull', description: 'Blablabla' },
      { label: 'Cargo', description: 'Fill this soon with commercial' },
      { label: 'Protection and Indemnity', description: 'Fill this soon with operational' },
    ],
  },
  {
    slug: 'construction',
    headline: ['Construction'],
    subtext:
      "Risks faced by companies in the construction businesses, construction project owners and developers range in diversity from environmental liability to workers’ compensation and from builder’s risk to professional liability.",
    image:
      '/image/construction.jpg',
    exhibit: 'Exhibit H — Construction',
    content: [
      { label: 'Contractor Liability', description: 'Blablabla' },
      { label: 'Delay on Start-up', description: 'Fill this soon with operational' },
    ],
  },
  {
    slug: 'travel',
    headline: ['Travel'],
    subtext:
      "Let us make your travel enjoyable and give you a peace of mind, be it for corporate or individual/family travels. Unfortunate situations could arise while you are abroad. ",
    image:
      '/image/travel.jpg',
    exhibit: 'Exhibit I — Travel',
    content: [
      { label: 'Health', description: 'Blablabla' },
      { label: 'Accident', description: 'Fill this soon with commercial' },
      { label: 'Evacuation', description: 'Fill this soon with operational' },
    ],
  },
];

function ServicesHero() {
  const [searchParams] = useSearchParams();

  // resolve which slide to start on, based on ?service= in the URL
  const initialIndex = (() => {
    const requested = searchParams.get('service');
    const found = SLIDES.findIndex((s) => s.slug === requested);
    return found !== -1 ? found : 0;
  })();

  const [index, setIndex] = useState(initialIndex);
  const [openItem, setOpenItem] = useState(null);
  const slide = SLIDES[index];

  // if the query param changes while already on the page (e.g. clicking
  // a footer link while already on /services), re-sync the slide
  useEffect(() => {
    const requested = searchParams.get('service');
    const found = SLIDES.findIndex((s) => s.slug === requested);
    setIndex(found !== -1 ? found : 0);
  }, [searchParams]);

  // close any open dropdown when the slide changes
  useEffect(() => {
    setOpenItem(null);
  }, [index]);

  const goNext = () => setIndex((i) => (i + 1) % SLIDES.length);
  const goPrev = () => setIndex((i) => (i - 1 + SLIDES.length) % SLIDES.length);

  return (
    <section className="relative bg-[#0e1e52] overflow-hidden">

      {/* faint hairline grid, evokes a ledger/schedule page */}
      <div
        className="absolute inset-0 opacity-[0.06] pointer-events-none"
        style={{
          backgroundImage:
            'linear-gradient(#fff 1px, transparent 1px), linear-gradient(90deg, #fff 1px, transparent 1px)',
          backgroundSize: '48px 48px',
        }}
      />

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-40 pb-24 lg:pt-48 lg:pb-32">
        <div className="hero-grid">

          {/* HEADER — eyebrow + headline */}
          <div className="header-area">
            <p className="font-mono text-xs tracking-[0.25em] text-[#ce381b] uppercase mb-6">
              Services Provided by Redoura
            </p>

            <h1
              key={`headline-${index}`}
              className="text-white text-4xl sm:text-5xl lg:text-6xl leading-[1.05] animate-fade-up"
              style={{ fontFamily: "'Fraunces', 'Georgia', serif" }}
            >
              {slide.headline.map((line, i) => (
                <React.Fragment key={i}>
                  {line}
                  {i < slide.headline.length - 1 && <br />}
                </React.Fragment>
              ))}
            </h1>
          </div>

          {/* IMAGE — framed carousel */}
          <div className="image-area relative">
            <div className="relative bg-[#F6F1E7] p-3 sm:p-4 shadow-2xl rotate-1">
              <div className="overflow-hidden relative h-[280px] sm:h-[380px] lg:h-[420px]">
                <img
                  key={`image-${index}`}
                  src={slide.image}
                  alt={slide.headline.join(' ')}
                  className="w-full h-full object-cover grayscale-[15%] animate-fade-in"
                />

                {/* arrows */}
                <button
                  onClick={goPrev}
                  aria-label="Previous"
                  className="absolute left-2 top-1/2 -translate-y-1/2 w-9 h-9 flex items-center justify-center rounded-full bg-[#150F3D]/70 hover:bg-[#150F3D] text-white transition"
                >
                  <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
                  </svg>
                </button>
                <button
                  onClick={goNext}
                  aria-label="Next"
                  className="absolute right-2 top-1/2 -translate-y-1/2 w-9 h-9 flex items-center justify-center rounded-full bg-[#150F3D]/70 hover:bg-[#150F3D] text-white transition"
                >
                  <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                  </svg>
                </button>
              </div>

              <div className="flex items-center justify-between mt-3 px-1">
                <p
                  key={`exhibit-${index}`}
                  className="font-mono text-[10px] tracking-widest text-[#8a7f68] uppercase animate-fade-in"
                >
                  {slide.exhibit}
                </p>

                {/* dot indicators */}
                <div className="flex gap-1.5">
                  {SLIDES.map((_, i) => (
                    <button
                      key={i}
                      onClick={() => setIndex(i)}
                      aria-label={`Go to slide ${i + 1}`}
                      className={`w-1.5 h-1.5 rounded-full transition ${
                        i === index ? 'bg-[#150F3D]' : 'bg-[#150F3D]/25'
                      }`}
                    />
                  ))}
                </div>
              </div>
            </div>

            {/* seal badge — the one signature element */}
            <div className="hidden sm:flex absolute -bottom-8 -left-8 w-28 h-28 rounded-full border border-dashed border-white/70 items-center justify-center text-center -rotate-6 bg-[#ce381b]">
              <span className="text-white text-[10px] tracking-widest uppercase leading-tight px-3">
                Certified<br />Protection
              </span>
            </div>
          </div>

          {/* REST — subtext, service list, CTA */}
          <div className="rest-area">
            <p
              key={`subtext-${index}`}
              className="text-white/60 text-base sm:text-lg leading-relaxed max-w-md mb-10 animate-fade-up-delay"
            >
              {slide.subtext}
            </p>

            <ul className="space-y-0 mb-10 border-t border-white/10">
              {slide.content.map((raw) => {
                // supports plain strings now, or { label, description } objects later
                const item =
                  typeof raw === 'string'
                    ? { label: raw, description: PLACEHOLDER_DESCRIPTION }
                    : { description: PLACEHOLDER_DESCRIPTION, ...raw };
                const isOpen = openItem === item.label;

                return (
                  <li key={item.label} className="border-b border-white/10">
                    <button
                      type="button"
                      onClick={() => setOpenItem(isOpen ? null : item.label)}
                      aria-expanded={isOpen}
                      className="w-full flex items-center justify-between py-4 font-mono text-white/80 hover:text-white text-sm sm:text-base text-left transition"
                    >
                      <span>{item.label}</span>
                      <svg
                        className={`w-4 h-4 text-[#B08D57] transition-transform duration-300 ${
                          isOpen ? 'rotate-180' : ''
                        }`}
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                      >
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                      </svg>
                    </button>

                    <div className={`accordion-panel ${isOpen ? 'open' : ''}`}>
                      <div>
                        <p className="pb-4 text-white/60 text-sm leading-relaxed">
                          {item.description}
                        </p>
                      </div>
                    </div>
                  </li>
                );
              })}
            </ul>

            {/* <a
              href="#contact"
              className="inline-flex items-center gap-3 border border-[#ce381b] text-[#ce381b] hover:bg-[#ce381b] hover:text-[#150F3D] px-7 py-3.5 text-sm tracking-wide uppercase transition duration-300"
            >
              Get a Quote
            </a> */}
          </div>

        </div>
      </div>

      <style>{`
        .hero-grid {
          display: grid;
          grid-template-columns: 1fr;
          grid-template-areas:
            "header"
            "image"
            "rest";
          row-gap: 2.5rem;
        }
        @media (min-width: 1024px) {
          .hero-grid {
            grid-template-columns: repeat(12, minmax(0, 1fr));
            column-gap: 2rem;
            row-gap: 1.5rem;
            grid-template-areas:
              "header header header header header header header image image image image image"
              "rest rest rest rest rest rest rest image image image image image";
          }
        }
        .header-area { grid-area: header; }
        .image-area { grid-area: image; align-self: center; }
        .rest-area { grid-area: rest; }

        @keyframes fadeUp {
          from { opacity: 0; transform: translateY(16px); }
          to { opacity: 1; transform: translateY(0); }
        }
        @keyframes fadeIn {
          from { opacity: 0; }
          to { opacity: 1; }
        }
        .animate-fade-up {
          animation: fadeUp 0.5s ease-out both;
        }
        .animate-fade-up-delay {
          animation: fadeUp 0.5s ease-out 0.1s both;
        }
        .animate-fade-in {
          animation: fadeIn 0.5s ease-out both;
        }

        .accordion-panel {
          display: grid;
          grid-template-rows: 0fr;
          transition: grid-template-rows 0.3s ease;
        }
        .accordion-panel.open {
          grid-template-rows: 1fr;
        }
        .accordion-panel > div {
          overflow: hidden;
        }

        @media (prefers-reduced-motion: reduce) {
          .animate-fade-up, .animate-fade-up-delay, .animate-fade-in {
            animation: none;
          }
          .accordion-panel { transition: none; }
        }
      `}</style>

    </section>
  );
}

export default ServicesHero;
